export const calendar = {
  types: {
    public_holiday: "Public holiday",
    national_day: "National day",
    religious: "Religious",
    observance: "Observance",
    international_day: "International day",
    crisis: "Crisis",
    global_event: "Global event",
  },
  moods: { celebratory: "Happy", neutral: "Neutral", solemn: "Solemn", sensitive: "Sensitive" },
  moodHints: {
    celebratory: "Celebrations: greetings and offers fit",
    neutral: "Informative days",
    solemn: "Sad or remembrance days: no promotions",
    sensitive: "Handle with care",
  },
  sources: { nager: "Public holidays", curated: "Malfak curated list", hijri: "Umm al-Qura (computed)", reliefweb: "Humanitarian alerts (UN)", gdelt: "News signals", brave: "Web search" },
  tones: { celebratory: "Celebratory", warm: "Warm", respectful: "Respectful", informative: "Informative", silent: "Stay quiet" },
  severity: { low: "Low", medium: "Medium", high: "High", critical: "Critical" },
  worldwide: "Worldwide",
  approximate: "±1 day",
  approximateHint: "Depends on the moon sighting, so it may move by a day",
  needsReview: "Needs review",
  dismissed: "Dismissed",
  event: {
    dates: "Dates",
    allDay: "All day",
    type: "Type",
    mood: "Mood",
    sources: "Sources",
    openSource: "Open source",
    confidence: "Confidence: {{value}}",
    severity: "Severity",
    guidance: "Posting guidance",
    tone: "Tone",
    do: "Do",
    dont: "Avoid",
    ideas: "Post ideas",
    hashtags: "Hashtags",
    createPost: "Create post for this day",
    dismiss: "Hide for my team",
    restore: "Show again",
    approve: "Confirm crisis",
    reject: "Not relevant",
    reviewHint: "Detected from news signals. Confirm it to alert your team and mark scheduled posts.",
    dismissedToast: "Hidden from your calendar",
    restoredToast: "Back on your calendar",
    approvedToast: "Crisis confirmed: your team has been alerted",
    rejectedToast: "Marked as not relevant",
    more: "+{{n}} events",
    eventsOn: "Calendar events on {{date}}",
  },
  overlay: { allDay: "All day" },
  subscribe: {
    button: "Calendar subscriptions",
    title: "Calendar subscriptions",
    description: "Pick the countries, kinds of days and moods your calendar should show. The preview updates before you save.",
    scope: "Applies to",
    orgDefault: "Whole organization",
    inherits: "This account uses the organization settings. Saving creates a custom setup for it.",
    override: "Custom setup for this account.",
    resetToOrg: "Use organization settings",
    resetDone: "This account follows the organization again",
    countries: "Countries",
    searchCountries: "Search countries",
    selected: "{{n}} selected",
    noMatch: "No country matches “{{q}}”",
    moodsFor: "What to show for {{country}}",
    categories: "Kinds of days",
    defaultMoods: "Moods",
    crisisAlerts: "Crisis alerts",
    crisisAlertsHint: "Banner and an instant notification when a crisis hits a country you follow",
    reminders: "Remind me before",
    remindersHint: "Days before each event",
    daysBefore: "{{n}} d",
    sameDay: "Same day",
    quietHours: "Quiet hours",
    quietHoursHint: "Reminders arrive silently in the tray (crisis alerts still notify)",
    from: "From",
    to: "To",
    preview: "Preview",
    previewHint: "What you will see with these settings",
    days90: "90 days",
    days365: "1 year",
    previewTotal: "{{n}} events",
    previewEmpty: "Nothing matches yet. Add a country or a mood.",
    previewMore: "+{{n}} more",
    save: "Save subscription",
    saved: "Calendar subscription saved",
    saveFailed: "Couldn't save the subscription",
    needCountry: "Pick at least one country or Worldwide",
  },
  crisis: {
    title: "Crisis alert",
    body: "{{title}}. Consider pausing promotional posts.",
    more: "and {{n}} more",
    view: "View",
    hide: "Hide alert",
  },
  conflict: {
    critical: "Falls on {{event}}: pause this post",
    warning: "Falls on {{event}}: consider rescheduling",
    review_tone: "Falls on {{event}}: review the tone",
    moveTo: "Move to {{when}}",
    moved: "Moved to {{when}}",
    pause: "Pause (back to draft)",
    paused: "Paused: moved back to drafts",
    badge: "Calendar conflict",
  },
  composer: {
    for: "Writing for {{event}}",
    drafting: "Drafting a caption for this day…",
    drafted: "AI draft ready in the right tone",
    avoid: "Avoid",
  },
  settings: {
    title: "Calendar",
    description: "National days, holidays and crises shown on your content calendar.",
    notifications: {
      title: "Calendar notifications",
      hint: "Only for you. Delivered in the app (tray and live toasts).",
      reminders: "Upcoming events",
      remindersHint: "Before the days you follow, with posting guidance",
      crisis: "Crisis alerts",
      crisisHint: "Immediately, high priority",
      conflicts: "Post conflicts",
      conflictsHint: "When a scheduled post falls on a solemn day or a crisis",
      digest: "Digest",
      digestOff: "Off",
      digestDaily: "Daily",
      digestWeekly: "Weekly",
      saved: "Notification preferences saved",
    },
    health: {
      title: "Sources",
      hint: "Every source is checked once a day, early in the morning. One failing source never stops the others.",
      source: "Source",
      status: "Status",
      lastSuccess: "Last success",
      details: "Details",
      never: "Never",
      refresh: "Refresh now",
      refreshing: "Refreshing the calendar…",
      refreshed: "Calendar refreshed",
      runs: "Recent runs",
      runLine: "+{{added}} added · {{changed}} changed · {{removed}} removed",
      statuses: { ok: "OK", failing: "Failing", disabled: "Off", never_ran: "Not run yet" },
    },
  },
  toast: { open: "Open" },
};
